import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";
import { track } from "../lib/analytics";
import { toast } from "sonner";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
    const { user } = useAuth();
    const [items, setItems] = useState([]);

    const load = useCallback(async () => {
        if (!user) { setItems([]); return; }
        try {
            const { data } = await api.get("/wishlist");
            setItems(data);
        } catch { setItems([]); }
    }, [user]);

    useEffect(() => { load(); }, [load]);

    const has = (productId) => items.some((p) => p.id === productId);

    const toggle = async (product) => {
        if (!user) {
            toast("Please sign in to save to your wishlist.");
            return { needsAuth: true };
        }
        if (has(product.id)) {
            await api.delete(`/wishlist/${product.id}`);
            setItems((cur) => cur.filter((p) => p.id !== product.id));
            toast("Removed from wishlist");
        } else {
            await api.post("/wishlist", { productId: product.id });
            setItems((cur) => [...cur, product]);
            track("add_to_wishlist", { item_id: product.id, item_name: product.name, price: product.price, item_category: product.category });
            toast("Added to wishlist");
        }
        return { ok: true };
    };

    return (
        <WishlistContext.Provider value={{ items, has, toggle, reload: load }}>
            {children}
        </WishlistContext.Provider>
    );
}

export function useWishlist() {
    return useContext(WishlistContext);
}
